import gql from 'graphql-tag';

export const QUERY_PROPERTIES_IN_POSTCODE = gql`
    query propertiesInPostcode($postcode: String!) {
        properties(postcode: $postcode) {
            fullAddress
            propertyId
        }
    }
`;
